import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { planzone, calendarHolidays } from "@planzone/dto";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createSelector } from "./selector";
import { State, Selector } from "./types";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  planzone,
  defaultCalendarHolidays: calendarHolidays,
};

function handleRequest(state: State): State {
  return { ...state, request: setRequestStateToPending() };
}

function handleSuccess({
  planzone,
  defaultCalendarHolidays,
}: Boundaries["assignDefaultCalendarHolidaysToPlanzone"]["success"]): State {
  return {
    request: setRequestStateToSuccess(),
    planzone,
    defaultCalendarHolidays,
  };
}

function handleFailure({
  planzone,
  defaultCalendarHolidays,
}: Boundaries["assignDefaultCalendarHolidaysToPlanzone"]["failure"]): State {
  return {
    request: setRequestStateToFailure(),
    planzone,
    defaultCalendarHolidays,
  };
}

const reduceState = createStateReducer(initialState, {
  [events.assignDefaultCalendarHolidaysToPlanzoneRequested]: handleRequest,
  [events.assignDefaultCalendarHolidaysToPlanzoneSucceeded]: handleSuccess,
  [events.assignDefaultCalendarHolidaysToPlanzoneFailed]: handleFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
